export const CAPABILITIES = Object.freeze([
  "view",
  "contribute",
  "edit",
  "approve",
  "manage",
]);

export const ROLE_CAPABILITIES = Object.freeze({
  viewer: Object.freeze(["view"]),
  contributor: Object.freeze(["view", "contribute"]),
  editor: Object.freeze(["view", "contribute", "edit"]),
  approver: Object.freeze(["view", "contribute", "edit", "approve"]),
  manager: CAPABILITIES,
});

export function normalizeCapabilities(roleOrCapabilities = "viewer") {
  if (Array.isArray(roleOrCapabilities)) {
    return new Set(roleOrCapabilities.filter((item) => CAPABILITIES.includes(item)));
  }

  return new Set(ROLE_CAPABILITIES[roleOrCapabilities] || ROLE_CAPABILITIES.viewer);
}

export function resolveCapabilities(role, workspaceAccess) {
  const roleCapabilities = normalizeCapabilities(role);
  if (!workspaceAccess) return roleCapabilities;

  const workspaceCapabilities = normalizeCapabilities(workspaceAccess);
  return new Set(
    [...roleCapabilities].filter((capability) => workspaceCapabilities.has(capability)),
  );
}

export function canPerform(role, capability, workspaceAccess) {
  return resolveCapabilities(role, workspaceAccess).has(capability);
}

export function permissionLabel(role, workspaceAccess) {
  const available = resolveCapabilities(role, workspaceAccess);
  return [...CAPABILITIES].reverse().find((capability) => available.has(capability)) || "none";
}
